import { render, staticRenderFns } from "./law_firms_add.vue?vue&type=template&id=49ff11d2&scoped=true"
import script from "./law_firms_add.vue?vue&type=script&lang=js"
export * from "./law_firms_add.vue?vue&type=script&lang=js"
import style0 from "./law_firms_add.vue?vue&type=style&index=0&id=49ff11d2&prod&scoped=true&lang=less"
import style1 from "./law_firms_add.vue?vue&type=style&index=1&id=49ff11d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ff11d2",
  null
  
)

export default component.exports